import { HEADER_MODIFY_TABLE_CONTENT_PROPERTY } from '@/corePagesModule/BaseTableContent/constants';
import { TableContentHeader } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';

export const orderTableContentHeader: TableContentHeader = {
  contentProperties: [
    {
      key: 'choice',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['choice'], propertyType: 'string' },
    },
    {
      key: 'OrderDate',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['OrderDate'], propertyType: 'IDate' },
    },
    {
      key: 'aggregateBusinessId',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['aggregateBusinessId'], propertyType: 'string' },
    },
    {
      key: 'warehouseNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouseNumber'], propertyType: 'string' },
    },
    {
      key: 'warehouse',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['warehouse'], propertyType: 'string' },
    },
    {
      key: 'supplierNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierNumber'], propertyType: 'string' },
    },
    {
      key: 'supplierName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['supplierName'], propertyType: 'string' },
    },
    {
      key: 'manufacturer',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['manufacturer'], propertyType: 'string' },
    },
    {
      key: 'businessNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessNumber'], propertyType: 'string' },
    },
    {
      key: 'businessName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['businessName'], propertyType: 'string' },
    },
    {
      key: 'package',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['package'], propertyType: 'number' },
    },
    {
      key: 'unit',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['unit'], propertyType: 'string' },
    },
    {
      key: 'OrderGroupName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['orderGroupName'], propertyType: 'string' },
    },
    {
      key: 'OrderInvoiceNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['orderGroupName'], propertyType: 'string' },
    },
    {
      key: 'OrderDestinationName',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['orderGroupName'], propertyType: 'string' },
    },
    {
      key: 'OrderDesiredTimeOfArrival',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: true,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['desiredDeliveryDate'], propertyType: 'IDate' },
    },
    {
      key: 'OrderIssuedNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'OrderDeleteButton',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: true,
      sortOption: {
        isSortable: false,
        isAsc: false,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'OrderNumber',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: true,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'OrderEstimateTimeOfArrival',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: true,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['estimatedTimeOfArrival'], propertyType: 'IDate' },
    },
    {
      key: 'OrderAmount',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: true,
      sortOption: {
        isSortable: true,
        isAsc: true,
      },
      propertyPath: { paths: ['orderAmount'], propertyType: 'number' },
    },
    {
      key: 'OrderRecommendStatus',
      isVariableWidth: false,
      isNarrowable: true,
      isEditable: true,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: ['orderStatus'], propertyType: 'string' },
    },
    {
      key: 'supplierForecastResponsibleUser',
      isVariableWidth: true,
      isNarrowable: true,
      isEditable: false,
      sortOption: { isSortable: true, isAsc: true },
      propertyPath: { paths: ['aggregateBusinessResponsibleUsers'], propertyType: 'string' },
    },
    {
      key: 'OrderAlert',
      isVariableWidth: true,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'OrderEditButton',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: true,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'OrderMemo',
      isVariableWidth: true,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'OrderBasis',
      isVariableWidth: true,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'OrderOutputDate',
      isVariableWidth: true,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: true, isAsc: true },
      propertyPath: { paths: ['outputDate'], propertyType: 'number' },
    },
    {
      key: 'OrderLastUpdatedBy',
      isVariableWidth: true,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: true, isAsc: true },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    {
      key: 'ReminderMail',
      isVariableWidth: false,
      isNarrowable: false,
      isEditable: false,
      sortOption: { isSortable: false, isAsc: true },
      propertyPath: { paths: [], propertyType: 'string' },
    },
    HEADER_MODIFY_TABLE_CONTENT_PROPERTY,
  ],
  options: {
    stableColumnCount: 1,
    resizableHeaderColumn: true,
  },
};
